/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  ExportDownlineReq,
  GetDownlineV2Res,
  GetFrontlineV2Res,
  GetProductRes,
  GetProductsRes,
} from "./data-contracts";
import type { RequestParams } from "./http-client";
import { ContentType, HttpClient } from "./http-client";

export default function useV2() {
  class V2<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Account
     * @name DownlineControllerGetDownline
     * @summary Getting the tree of children of the position
     * @request GET:/api3/v2/account/{id}/downline
     * @secure
     * @response `200` `GetDownlineV2Res`
     * @response `400` `BaseErrorResponse`
     */
    downlineControllerGetDownline = (
      id: number,
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example 0 */
        treeId?: any;
        /** @example 2 */
        includeTree?: any;
        /** @example null */
        positionId?: any;
        /**
         * @min 1
         * @example 1
         */
        offset?: any;
        /**
         * Sampling depth
         * @min 0
         * @example 3
         */
        depth?: any;
        /**
         * Show deleted or disabled accounts. Administrator only
         * @example false
         */
        showInactiveAccounts?: boolean;
        /**
         * Show disabled accounts
         * @example false
         */
        showDisabledAccounts?: boolean;
        /**
         * Period ID
         * @example 3
         */
        periodId?: any;
        /**
         * Requested marketing properties
         * @example ["PV","AR"]
         */
        properties?: string[];
        /**
         * Order by
         * @example {"account.created_at":"ASC"}
         */
        orderBy?: Record<string, string>;
        filter?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetDownlineV2Res, BaseErrorResponse>({
        path: `/api3/v2/account/${id}/downline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      });
    /**
     * No description
     *
     * @tags Account
     * @name DownlineControllerStartExport
     * @summary Starts export operation
     * @request POST:/api3/v2/account/{id}/downline/export
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    downlineControllerStartExport = (id: number, data: ExportDownlineReq, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/v2/account/${id}/downline/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      });
    /**
     * No description
     *
     * @tags Account
     * @name FrontLineControllerGetFrontline
     * @summary Getting the children of the position
     * @request GET:/api3/v2/account/{id}/frontline
     * @secure
     * @response `200` `GetFrontlineV2Res`
     * @response `400` `BaseErrorResponse`
     */
    frontLineControllerGetFrontline = (
      id: number,
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example 0 */
        treeId?: any;
        /** @example null */
        positionId?: any;
        /**
         * @min 1
         * @example 1
         */
        offset?: any;
        /**
         * Show deleted or disabled accounts. Administrator only
         * @example false
         */
        showInactiveAccounts?: boolean;
        /**
         * Show disabled accounts
         * @example false
         */
        showDisabledAccounts?: boolean;
        /**
         * Requested marketing properties
         * @example ["PV","AR"]
         */
        properties?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetFrontlineV2Res, BaseErrorResponse>({
        path: `/api3/v2/account/${id}/frontline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      });
    /**
     * No description
     *
     * @tags POS
     * @name PosProductV2ControllerGetProducts
     * @request GET:/api3/v2/pos/product
     * @response `200` `GetProductsRes`
     * @response `400` `BaseErrorResponse`
     */
    posProductV2ControllerGetProducts = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /**
         * Requested categories
         * @example [1,2]
         */
        categoryIds?: string[];
        /**
         * Exclude categories from the sample
         * @example [1,2]
         */
        excludedCategoryIds?: string[];
        /** @example 1 */
        priceListId?: any;
        /** @example 1 */
        posId?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProductsRes, BaseErrorResponse>({
        path: `/api3/v2/pos/product`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      });
    /**
     * No description
     *
     * @tags POS
     * @name PosProductV2ControllerGetProduct
     * @request GET:/api3/v2/pos/product/{productId}
     * @response `200` `GetProductRes`
     * @response `400` `BaseErrorResponse`
     */
    posProductV2ControllerGetProduct = (
      productId: any,
      query?: {
        /** @example 1 */
        priceListId?: any;
        /** @example 1 */
        posId?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProductRes, BaseErrorResponse>({
        path: `/api3/v2/pos/product/${productId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      });
  }

  return new V2();
}
